module.exports = __webpack_public_path__ + "img/3.4a5f6810.jpg";